import { createActionGroup, emptyProps, props } from '@ngrx/store'
import {
    CaseId,
    MarkerDimension,
    SegObjectPropertyMap,
    RecurrentNeighborhoodsResult,
    NeighborhoodEnrichmentResult,
    CellTypeDetectionResult,
    TsneResult,
    UmapResult,
} from './case.state'
import { HttpErrorResponse } from '@angular/common/http'

export const caseActions = createActionGroup({
    source: 'Case',
    events: {
        'Select Case': props<{ caseId: CaseId }>(), // manual case selection (triggers route change)
        'Load Case': props<{ caseId: CaseId; caseName: string | undefined; shared: boolean }>(),
        'Reload Case': emptyProps(),
        'Loading Markers Succeeded': props<{ markers: MarkerDimension[] }>(),
        'Loading Markers Failed': props<{ error: HttpErrorResponse; message: string }>(),
        'Loading Seg Object Property Maps Succeeded': props<{
            segobjectpropertymaps: SegObjectPropertyMap[]
        }>(),
        'Loading Seg Object Property Maps Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Select Seg Object Property Map': props<{ segobjectpropertymap: SegObjectPropertyMap }>(),
        'Load Seg Object Properties Data': props<{
            caseId: CaseId
            segobjectpropertymap: SegObjectPropertyMap
        }>(),
        'Loading Seg Object Properties Data Succeeded': props<{
            segobjectpropertiesdata: MarkerDimension[]
        }>(),
        'Loading Seg Object Properties Data Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Loading Recurrent Neighborhoods Results Succeeded': props<{
            neighborhood: RecurrentNeighborhoodsResult[]
        }>(),
        'Loading Recurrent Neighborhoods Results Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Loading Neighborhood Enrichment Results Succeeded': props<{
            neighborhood: NeighborhoodEnrichmentResult[]
        }>(),
        'Loading Neighborhood Enrichment Results Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Loading Tsne Results Succeeded': props<{
            tsne: TsneResult[]
        }>(),
        'Loading Tsne Results Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Loading Umap Results Succeeded': props<{
            umap: UmapResult[]
        }>(),
        'Loading Umap Results Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Loading Auto Cell Detection Results Succeeded': props<{
            autoCellDetection: CellTypeDetectionResult[]
        }>(),
        'Loading Auto Cell Detection Results Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Loading Plotting Results Succeeded': props<{
            plotting: any
        }>(),
        'Loading Plotting Results Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
    },
})
